import { axiosInstance as request } from '@api/rest.service'
import { getFilters } from '@/modular-api/utils'

const api = '/subscription-periods'

/**
 * @description GET /subscription-periods
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_PERIODS = () => request.get(api)

/**
 * @description GET /subscription-periods?include=subscription,publisher,vendor&filter[starts_in_year]=2003
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTIONS_PERIODS_WITH_FILTERS = (
  year,
  include = 'subscription,publisher,vendor,financialPeriod'
) => {
  return request.get(api, {
    params: {
      include,
      'filter[starts_in_year]': year
    }
  })
}

const include = 'status,publisher,vendor,departments,previousPeriod,subscription.product'

/**
 * @description GET /subscription-periods?paginated=true&startRow=0&endRow=40&include=status,publisher,vendor,previousPeriod&filter[financial_period.id]={id}
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_SUBSCRIPTIONS_PERIODS_FOR_FINANCIAL_PERIOD = (
  id,
  params,
  moreIncludes = '',
  additionalFilters = {}
) => {
  return request.get(`${api}?paginated=true`, {
    params: {
      ...params,
      include: !!moreIncludes ? `${include},${moreIncludes}` : include,
      'filter[financial_period.id]': id,
      ...additionalFilters
    }
  })
}

/**
 * @description PATCH /subscription-periods/:id?include=status,publisher,vendor,previous_period
 * @returns {AxiosPromise<any>}
 */

export const MODIFY_SUBSCRIPTION_PERIOD_FOR_FINANCIAL_PERIOD = (id, payload, moreIncludes) => {
  const includes = !!moreIncludes ? `${include},${moreIncludes}` : include
  return request.patch(`${api}/${id}?include=${includes}`, payload)
}

/**
 * @description PATCH /subscription-periods/forecasted-price-change
 * @returns {AxiosPromise<any>}
 */

export const CHANGE_FORECASTED_PRICE_FOR_SUBSCRIPTION_PERIODS = payload =>
  request.patch(`${api}/forecasted-price-change`, payload)

/**
 * @description GET /subscription-periods/create
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_PERIODS_CREATE = () => request.get(`${api}/create`)

/**
 * @description GET /subscription-periods/create/subscription/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_TASK_APPLICABILITY_FOR_SUB = subId => request.get(`${api}/create/subscription/${subId}`)

/**
 * @description PATCH /subscription-periods/recommendation-status
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_SUB_PERIODS_RECOMMENDATION_STATUS = payload =>
  request.patch(`${api}/recommendation-status`, payload)

/**
 * @description PATCH /subscription-periods/proposal-status
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_SUB_PERIODS_PROPOSAL_STATUS = payload => request.patch(`${api}/proposal-status`, payload)

/**
 * @description GET /subscription-periods/${id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_PERIOD = id => request.get(`${api}/${id}`)

/**
 * @description GET /subscription-periods/${id}/accept
 * @returns {AxiosPromise<any>}
 */
export const ACCEPT_SUBSCRIPTION_PERIOD = id => request.get(`${api}/${id}/accept`)

/**
 * @description GET /subscription-periods/${id}/cancel
 * @returns {AxiosPromise<any>}
 */
export const CANCEL_SUBSCRIPTION_PERIOD = id => request.get(`${api}/${id}/cancel`)

/**
 * @description POST /subscription-periods/accept
 * @returns {AxiosPromise<any>}
 */
export const ACCEPT_SUBSCRIPTION_PERIODS = payload => request.post(`${api}/accept`, payload)

/**
 * @description POST /subscription-periods/cancel
 * @returns {AxiosPromise<any>}
 */
export const CANCEL_SUBSCRIPTION_PERIODS = payload => request.post(`${api}/cancel`, payload)

/**
 * @description POST /subscription-periods
 * @returns {AxiosPromise<any>}
 */
export const CREATE_SUBSCRIPTION_PERIOD = payload => request.post(api, payload)

/**
 * @description PATCH /subscription-periods/${id}?include={entities}
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_SUBSCRIPTION_PERIOD = (id, payload, includes) => {
  if (includes) return request.patch(`${api}/${id}?include=${includes.join(',')}`, payload)
  return request.patch(`${api}/${id}`, payload)
}

/**
 * @description PATCH /subscription-periods
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_SUBSCRIPTION_PERIODS = payload => request.patch(api, payload)

/**
 * @description GET /subscription-periods/${id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_PERIOD_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /subscription-periods/${id}
 * @returns {AxiosPromise}
 */
export const DELETE_SUBSCRIPTION_PERIOD = id => request.delete(`${api}/${id}`)

/**
 * @description GET /subscription-periods/start-years
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_PERIOD_START_YEARS = () => request.get(`${api}/start-years`)

/**
 * @description GET /subscription-periods/recommendation-statuses
 * @returns {AxiosPromise<any>}
 */

export const GET_SUB_PERIOD_RECOMMENDATION_STATUSES = () => request.get(`${api}/recommendation-statuses`)

/**
 * @description GET /subscription-periods/proposal-statuses
 * @returns {AxiosPromise<any>}
 */
export const GET_SUB_PERIOD_PROPOSAL_STATUSES = () => request.get(`${api}/proposal-statuses`)

/**
 * @description GET /subscription-periods/proposal-statuses-with-subscription-ids?excluded_ids[]=1&excluded_ids[]=2&filter_financial_period_id=6&filter_department_id=1
 * @returns {AxiosPromise<any>}
 */
export const GET_PROPOSAL_STATUSES_WITH_SUB_IDS = params =>
  request.get(`${api}/proposal-statuses-with-subscription-ids`, { params })

/**
 * @description PATCH /subscription-periods/bulk-update
 * @returns {AxiosPromise<any>}
 */

export const BULK_UPDATE_SUB_PERIODS = (payload, filters) => {
  const params = getFilters(filters)

  return request.patch(`${api}/bulk-update`, payload, { params })
}
